/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function GlobalInterceptor($rootScope, $q, $injector) {

    var toast;
    var translate;
    var userService;
    var types;
    var tkDialogs;
    var http;

    var internalUrlPrefixes = [
        '/api/auth/token',
        '/api/plugins/rpc'
    ];

    var service = {
        request: request,
        requestError: requestError,
        response: response,
        responseError: responseError
    }

    return service;

    function getToast() {
        if (!toast) {
            toast = $injector.get("toast");
        }
        return toast;
    }

    function getTranslate() {
        if (!translate) {
            translate = $injector.get("$translate");
        }
        return translate;
    }

    function getUserService() {
        if (!userService) {
            userService = $injector.get("userService");
        }
        return userService;
    }

    function getTypes() {
        if (!types) {
            types = $injector.get("types");
        }
        return types;
    }

    function getTkDialogs() {
        if (!tkDialogs) {
            tkDialogs = $injector.get("tkDialogs");
        }
        return tkDialogs;
    }

    function getHttp() {
        if (!http) {
            http = $injector.get("$http");
        }
        return http;
    }

    function rejectionErrorCode(rejection) {
        if (rejection && rejection.data && rejection.data.errorCode) {
            return rejection.data.errorCode;
        } else {
            return undefined;
        }
    }

    function isTokenBasedAuthEntryPoint(url) {
        return  url.includes('/api/') &&
               !url.includes(getTypes().entryPoints.login) &&
               !url.includes(getTypes().entryPoints.tokenRefresh) &&
               !url.includes(getTypes().entryPoints.nonTokenBased);
    }

    function refreshTokenAndRetry(request) {
        return getUserService().refreshJwtToken().then(function success() {
            getUserService().updateAuthorizationHeader(request.config.headers);
            return getHttp()(request.config);
        }, function fail(message) {
            $rootScope.$broadcast('unauthenticated');
            request.status = 401;
            request.data = {};
            request.data.message = message || getTranslate().instant('access.unauthorized');
            return $q.reject(request);
        });
    }

    function isInternalUrlPrefix(url) {
        for (var index in internalUrlPrefixes) {
            if (url.startsWith(internalUrlPrefixes[index])) {
                return true;
            }
        }
        return false;
    }

    function updateConfigUrl(config) {
        // eslint-disable-next-line
        return process.env.NODE_ENV === 'production' ? `https://${window.DynamicConfigs.appHost}${config.url}` : config.url;
    }
 
    function request(config) {
        var rejected = false;
        if (config.url.startsWith('/api/')) {
            var isLoading = !isInternalUrlPrefix(config.url);
            updateLoadingState(config, isLoading);
            if (isTokenBasedAuthEntryPoint(config.url)) {
                if (!getUserService().updateAuthorizationHeader(config.headers) &&
                    !getUserService().refreshTokenPending()) {
                    updateLoadingState(config, false);
                    rejected = true;
                    getUserService().clearJwtToken(false);
                    return $q.reject({ data: {message: getTranslate().instant('access.unauthorized')}, status: 401, config: config});
                } else if (!getUserService().isJwtTokenValid()) {
                    return $q.reject({ refreshTokenPending: true, config: config });
                }
            }
            // At this point we are overriding local url to the one from the environment variable
            config.url = updateConfigUrl(config);
            if (!config.timeout) {
                config.cancel  = $q.defer();
                config.timeout = config.cancel.promise;
            }
        }
        if (!rejected) {
            return config;
        }
    }

    function requestError(rejection) {
        if (rejection.config.url.includes('/api/')) {
            updateLoadingState(rejection.config, false);
        }
        return $q.reject(rejection);
    }

    function response(response) {
        if (response.config.url.includes('/api/')) {
            updateLoadingState(response.config, false);
        }
        return response;
    }

    function responseError(rejection) {
        if (rejection.config.url.includes('/api/')) {
            updateLoadingState(rejection.config, false);
        }
        var unhandled = false;
        var errorCode = rejectionErrorCode(rejection);
        var ignoreErrors = rejection.config.ignoreErrors;
        if (rejection.refreshTokenPending || rejection.status === 401) {
            if (rejection.refreshTokenPending || (errorCode && errorCode === getTypes().serverErrorCode.jwtTokenExpired)) {
                return refreshTokenAndRetry(rejection);
            } else if (isTokenBasedAuthEntryPoint(rejection.config.url) && errorCode && errorCode === getTypes().serverErrorCode.authentication) {
                getUserService().clearJwtToken(true);
            } else {
                unhandled = true;
            }
        } else if (rejection.status === 403) {
            if (!ignoreErrors) {
                if (errorCode && errorCode === getTypes().serverErrorCode.subscriptionViolation) {
                    getTkDialogs().subscriptionViolation(null, rejection);
                } else {
                    $rootScope.$broadcast('forbidden');
                }
            }
        } else if (rejection.status === 0) {
            getToast().showError(getTranslate().instant('error.unable-to-connect'));
        } else if (rejection.status === -1) {  
            // don't show an error message for aborted requests
        } else if (rejection.status === 404) {
            if (!ignoreErrors && !rejection.data) {
                getToast().showError(rejection.config.method + ": " + rejection.config.url + "<br/>" +
                    rejection.status + ": " + rejection.statusText);
            } else {
                unhandled = true;
            }
        } else {
            unhandled = true;
        }

        if (unhandled && !ignoreErrors) {
            if (rejection.data && !rejection.data.message) {
                getToast().showError(rejection.data);
            } else if (rejection.data && rejection.data.message) {
                getToast().showError(rejection.data.message);
            } else {
                getToast().showError(getTranslate().instant('error.unhandled-error-code', {errorCode: rejection.status}));
            }
        }
        return $q.reject(rejection);
    }

    function updateLoadingState(config, isLoading) {
        if (!config || angular.isUndefined(config.ignoreLoading) || !config.ignoreLoading) {
            $rootScope.loading = isLoading;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/global-interceptor.service.js